import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Divider} from 'antd';
import {InfoCircleOutlined} from '@ant-design/icons';
import {useDispatch, useSelector} from 'react-redux';
import {StyledBudgetRequestInfo, StyledBudgetRequestInfoTitle, StyledBudgetRequestInfoSpace} from './StyledBudgetRequestInfo';
import BudgetLineItemsTable from '../BudgetLineItemsTable';
// import BudgetPolicyQuestions from '../BudgetPolicyQuestions';
import BudgetRequestDetails from '../BudgetRequestDetails';
import {budgetActions} from '../../../../state/actions/budget.actions';
import {budgetHelpers} from '../../../../utils/helpers';

const BudgetRequestInfo = ({
  onlyReadView = false,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const budget = useSelector(state => state?.budget?.budgetRequest);

  const dispatch = useDispatch();

  const isEditableBudget = budgetHelpers.isEditableBudget(budget);

  const isEnabledLineItems = useMemo(() => {
    const isPurchaseOrder = budgetHelpers.isPurchaseOrderBudget(budget);
    if (!isPurchaseOrder) return false;

    if (budgetHelpers.isEditableBudget(budget)) {
      return true;
    }

    return (budget?.items || []).length > 0;
  }, [budget]);

  const handleEditBudget = ({data} = {}) => {
    const budgetId = budget?.id;
    if (!budgetId) return;

    dispatch(
      budgetActions.updateBudgetRequest({
        id: budgetId,
        data,
      })
    );
  }

  const budgetFormProps = {
    budget,
    onEdit: handleEditBudget,
    editable: isEditableBudget,
  }

  return (
    <StyledBudgetRequestInfo size='large' direction='vertical' {...rest}>
      <BudgetRequestDetails {...budgetFormProps} onlyReadView={onlyReadView} />
      {isEnabledLineItems && (
        <>
          <Divider />
          <StyledBudgetRequestInfoSpace size='small' direction='vertical'>
            <StyledBudgetRequestInfoTitle>
              {t('lineItems')} <InfoCircleOutlined />
            </StyledBudgetRequestInfoTitle>
            <BudgetLineItemsTable {...budgetFormProps} />
          </StyledBudgetRequestInfoSpace>
        </>
      )}

      {/*<Divider />*/}
      {/*<BudgetPolicyQuestions budget={budget} onEdit={handleEditBudget} />*/}
    </StyledBudgetRequestInfo>
  );
}

export default BudgetRequestInfo;
